import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import {useEffect} from 'react';
import './index.scss';

const dropList = [
  {
    link: '/game',
    title: '车联网服务',
  },
  {
    link: '/hmi',
    title: '智慧工厂开发',
  },
  {
    link: '/industry',
    title: '人工智能AI+',
  },
  {
    link: '/model',
    title: '大模型定制训练',
  },
];

const Header = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleScroll = (domCls) => {
    if (!window.location.hash.includes('index')) {
      navigate('/index');

      setTimeout(() => {
        window.scrollTo(0, document.querySelector(domCls)?.offsetTop - 70);
      }, 500);

      return;
    }

    window.scrollTo(0, document.querySelector(domCls)?.offsetTop - 70);
  };

  const getHash = () => {
    return window.location.hash.split('?')[0]
  }

  useEffect(() => {
    setTimeout(() => {
      let domCls = new URLSearchParams(location.search).get('dom');
      if (!domCls) return;
      domCls = `.${domCls}`;
      console.log('domCls', domCls)
      window.scrollTo(0, (document.querySelector(domCls) as any).offsetTop - 100);
    }, 400)
  }, [location.search])

  return (
    <div>
      <div className="header-placeholder"></div>
      <div className="header">
        <div className="header-left">
          <Link to="/index">
            <div className="header-logo logo"></div>
          </Link>
          <div className="header-menus">
            <NavLink to="/index" className="header-menus_item">
              首页
            </NavLink>
            <span className={`header-menus_item ${['#/game', '#/hmi', '#/industry', '#/model'].includes(getHash()) ? 'active' : ''}`}>
              解决方案与产品
              <ul className="header-menus_item-dropList">
                {dropList.map((item) => (
                  <li className={`dropList-item`} key={item.link}>
                    <Link to={item.link} className={`${window.location.href.includes(item.link) ? 'active' : ''}`}>
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </span>
            <span className="header-menus_item" onClick={() => handleScroll('#features-wrapper')}>方案简介</span>
            <span className="header-menus_item" onClick={() => handleScroll('#roadmap')}>产品优势</span>
            {/* <NavLink to="/about-us" className="header-menus_item">
              关于我们
            </NavLink> */}
          </div>
        </div>
        <div className="header-right">
          <div className="header-menus">
            <NavLink to="/login" className="header-menus_item">
              登录
            </NavLink>
            <NavLink to="/register" className="header-menus_item register">
              注册
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
